import { getEndpoint } from "../utils/stringUtil";
import client from "./axios";
import { Roles } from "../enums/Roles";

export interface MentoringPartner {
  id: number;
  nome: string;
  cognome: string;
  email: string;
  role: Roles;
}

export type MentoringFileType = "image" | "video" | "document" | "other";

export interface MentoringItem {
  id: number;
  trainerId: number;
  athleteId: number;
  ownerId: number;
  title: string;
  description: string | null;
  tags: string[] | null;
  path: string;
  fileType: MentoringFileType;
  originalName: string | null;
  signedUrl?: string;
  owner?: { id: number; nome: string; cognome: string };
  createdAt?: string;
}

const base = `${getEndpoint()}api/mentoring`;

export const Mentoring = {
  getPartners: () => client.get<{ list: MentoringPartner[] }>(`${base}/partners`),
  getItems: (partnerId: number) =>
    client.get<{ list: MentoringItem[] }>(`${base}/${partnerId}/items`),
  createItem: (partnerId: number, formData: FormData) =>
    client.post<{ item: MentoringItem }>(`${base}/${partnerId}/items`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteItem: (id: number) => client.delete(`${base}/items/${id}`),
};
